import './firebase';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Container, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { onAuthStateChanged, getAuth } from '@firebase/auth';
import { useEffect, useState } from 'react';

import Navigation from './components/Navigation';
import Home from './pages/Home';
import Account from './pages/Account';
import Register from './pages/Register';
import Login from './pages/Login';
import Signup from './pages/Signup';
import NotFound from './pages/NotFound';

import { UserContext } from './components/UserContex';
import Admin from './pages/Admin';
import Terms from './pages/Terms';
import Header from './components/Header';
import fotballystTheme from './Theme';

const App = () => {
  const [user, setUser] = useState(null);

  const auth = getAuth();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => setUser(user ?? null));
  }, [auth]);

  return (
    <Router>
      <CssBaseline>
        <ThemeProvider theme={fotballystTheme}>
          <UserContext.Provider value={user}>
            <Header />
            <Container sx={{ maxWidth: '700px', padding: '2em 2em 5em 2em', margin: 'auto' }}>
              <Switch>
                <Route path="/" component={Home} exact />
                <Route path="/register" component={Register} exact />
                <Route path="/account" component={Account} exact />
                <Route path="/login" component={Login} exact />
                <Route path="/signup" component={Signup} exact />
                <Route path="/admin" component={Admin} exact />
                <Route path="/terms" component={Terms} exact />
                <Route path="*" component={NotFound} />
              </Switch>
            </Container>
            <Navigation />
          </UserContext.Provider>
        </ThemeProvider>
      </CssBaseline>
    </Router>
  );
};

export default App;
